import App from 'Components/vaccination';
import fetchJson from 'Utils/fetchJson';
import getLocales from 'Utils/getLocales';
import { getVaccinationContent } from 'Utils/getContent';
import { globalTrackerAPIRoot } from 'Constants/locations';

const Page = (props) => {
  return (<App {...props} />);
};

export default Page;

export const getStaticProps = async({ params }) => {
  // Content
  const content = getVaccinationContent('en');

  // Statistics
  const globalStatistics = await fetchJson(`${globalTrackerAPIRoot}/statistics.json`);
  const priorityGroupsSummaryStatistics = await fetchJson('https://graphics.thomsonreuters.com/data/2021/covid-vaccine-priority-groups-tracker/summary.json');
  const vaccinationSummaryStatistics = await fetchJson('https://graphics.thomsonreuters.com/data/2020/coronavirus/owid-covid-vaccinations/latest-perpop-data-all.json');

  return ({
    props: {
      ...params,
      content,
      globalStatistics,
      vaccinationSummaryStatistics,
      priorityGroupsSummaryStatistics,
      locale: 'en',
      locales: getLocales(),
    },
  });
};
